/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SiteMapAnalytics } from './SiteMapAnalytics';
import {
    SiteMapAnalyticsFromJSON,
    SiteMapAnalyticsFromJSONTyped,
    SiteMapAnalyticsToJSON,
    SiteMapAnalyticsToJSONTyped,
} from './SiteMapAnalytics';

/**
 * 
 * @export
 * @interface PaginatedSiteMapAnalyticsList
 */
export interface PaginatedSiteMapAnalyticsList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedSiteMapAnalyticsList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSiteMapAnalyticsList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<SiteMapAnalytics>}
     * @memberof PaginatedSiteMapAnalyticsList
     */
    results: Array<SiteMapAnalytics>;
}

/**
 * Check if a given object implements the PaginatedSiteMapAnalyticsList interface.
 */
export function instanceOfPaginatedSiteMapAnalyticsList(value: object): value is PaginatedSiteMapAnalyticsList {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedSiteMapAnalyticsListFromJSON(json: any): PaginatedSiteMapAnalyticsList {
    return PaginatedSiteMapAnalyticsListFromJSONTyped(json, false);
}

export function PaginatedSiteMapAnalyticsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedSiteMapAnalyticsList {
    if (json == null) {
        return json;
    }
    return {
        
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(SiteMapAnalyticsFromJSON)),
    };
}

export function PaginatedSiteMapAnalyticsListToJSON(json: any): PaginatedSiteMapAnalyticsList {
    return PaginatedSiteMapAnalyticsListToJSONTyped(json, false);
}

export function PaginatedSiteMapAnalyticsListToJSONTyped(value?: PaginatedSiteMapAnalyticsList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(SiteMapAnalyticsToJSON)),
    };
}

